import React from 'react';
import { breakpoints } from '@naf/theme';
import { ArticleHeader } from '@naf-simba/sections-headers';
import { BreadcrumbData } from 'use-react-router-breadcrumbs';
import { GridCol } from '@naf/grid';
import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { HeroWithTitleAndWideImageType } from '@pages/DynamicApp/Hero/HeroWithTitleAndWideImage';
import BreadCrumb from '@components/breadcrumb/BreadCrumb';
import { HeroImages } from '@components/image/HeroImages';
import { ThemeVariants } from '@appTypes/themes';
import { FullScreenHeaderWrapper } from './styles';

export const TitleAndWideImageHero = ({
  hero: { header, image, mobileImage, ingress, overlay, halfScreen },
  breadCrumbs,
  themeType,
}: {
  hero: HeroWithTitleAndWideImageType;
  breadCrumbs?: BreadcrumbData[];
  themeType?: string;
}) => {
  if (image?.public_id || image?.publicId) {
    return (
      <FullScreenHeaderWrapper>
        {breadCrumbs && breadCrumbs.length > 1 ? (
          <BreadcrumbWrapper>
            <GridCol>
              <BreadCrumb />
            </GridCol>
          </BreadcrumbWrapper>
        ) : null}
        <ArticleHeader
          imageOrVideo={
            <HeroImages
              image={image}
              mobileImage={mobileImage}
              cropOnSmallScreens={themeType === ThemeVariants.JustSuper}
              halfScreen={halfScreen}
              alt={image.alt || image.altText || image.caption || undefined}
            />
          }
          ingress={ingress}
          title={header}
          headingVariant="display"
          nafBranded={false}
          overlay={overlay}
          halfScreen={halfScreen}
        />
      </FullScreenHeaderWrapper>
    );
  }
  return <ArticleHeader nafBranded={false} ingress={ingress} title={header} halfScreen={halfScreen} />;
};

const BreadcrumbWrapper = styled.div`
  position: absolute;
  margin: 0 auto;
  padding: 0 48px;
  top: 90px;
  max-width: 1120px;
  right: 0;
  left: 0;
  z-index: 10;
  display: flex;
  @media (max-width: ${breakpoints.m}) {
    top: 60px;
    padding: 0 24px;
  }
  * {
    color: ${nafColor.signature.white} !important;
    text-decoration-color: ${nafColor.signature.white};
  }
`;
